import { render } from "./FormManagement.vue?vue&type=template&id=0502cb40&scoped=true"
import script from "./FormManagement.js?vue&type=script&lang=js"
export * from "./FormManagement.js?vue&type=script&lang=js"

import "./FormManagement.vue?vue&type=style&index=0&id=0502cb40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0502cb40"]])

export default __exports__